/* Common Imports */

import { styled, useMediaQuery } from "@mui/system";
import React from "react";

/* Redux & Type Imports */

import { ObjectId } from "mongoose";
import StateInterface from "../../../redux-magic/state-interface";
import {
	createNewPropertyWithUploadToolThunk,
	setCreateNePropertyMinBalconiesThunk,
	setCreateNewePropertyPossessionDateThunk,
	setCreateNewPropertyAgeThunk,
	setCreateNewPropertyAvailabiltyThunk,
	setCreateNewPropertyDefaultLocationThunk,
	setCreateNewPropertyFloorNoThunk,
	setCreateNewPropertyFurnishingThunk,
	setCreateNewPropertyLandAreaThunk,
	setCreateNewPropertyLandAreaUnitThunk,
	setCreateNewPropertyLandFacingThunk,
	setCreateNewPropertyMaxBalconiesThunk,
	setCreateNewPropertyMaxBathroomsThunk,
	setCreateNewPropertyMaxBedroomsThunk,
	setCreateNewPropertyMaxCarpetAreaThunk,
	setCreateNewPropertyMaxFloorsThunk,
	setCreateNewPropertyMaxPriceThunk,
	setCreateNewPropertyMaxSuperBuiltUpAreaThunk,
	setCreateNewPropertyMinBathroomsThunk,
	setCreateNewPropertyMinBedroomsThunk,
	setCreateNewPropertyMinCarpetAreaThunk,
	setCreateNewPropertyMinPriceThunk,
	setCreateNewPropertyMinSuperBuiltUpAreaThunk,
	setCreateNewPropertyNoOfSeatsThunk,
	setCreateNewPropertyNoOfUnitsThunk,
	setCreateNewPropertyOverviewThunk,
	setCreateNewPropertyPlotDimensionsThunk,
	setCreateNewPropertySecurityDepositThunk,
	setCreateNewPropertySubTypeThunk,
	setCreateNewPropertySuperBuiltUpAreaUnitThunk,
	setCreateNewPropertyTransactionTypeThunk,
	setCreateNewPropertyTypeThunk,
	setCreateNewPropertyUnitFacingThunk,
	setCreateNewPropertyUploadImagesThunk,
	setPreviousPropertyDataThunk,
	setPropertyImagesUploadCompletedThunk,
} from "../../../redux-magic/store";
import { BeegruUserProfileContext } from "../../../redux-magic/sub-interfaces/redux-session-interface";
import { DbUserPage } from "../../../redux-magic/sub-interfaces/user-interface";
import {
	draftResumeStep,
	draftToNewPropertyData,
	fetchWebPropertyDraft,
	newPropertyDataToDraftBody,
	saveWebPropertyDraft,
} from "../../../lib/listings/webPropertyDraft";

/* Component Imports */

import {
	Alert,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	FormControl,
	FormHelperText,
	IconButton,
	InputLabel,
	LinearProgress,
	MenuItem,
	Select,
	Slide,
	Snackbar,
	TextField,
	Tooltip,
	Typography,
	useTheme,
} from "@mui/material";
import BeegruButton from "../../common-components/buttons/BeegruButton";
import PropertyConfig from "./sub-components/CreatePropertySubComponents/PropertyConfig";
import PropertyDetails from "./sub-components/CreatePropertySubComponents/PropertyDetails";
import PropertyLocation from "./sub-components/CreatePropertySubComponents/PropertyLocation";
import PropertyOverview from "./sub-components/CreatePropertySubComponents/PropertyOverview";
import PropertyPreview from "./sub-components/CreatePropertySubComponents/PropertyPreview";
import SuccessPage from "./sub-components/CreatePropertySubComponents/SuccessPage";
import UploadImages from "./sub-components/CreatePropertySubComponents/UploadImages";

/* Icon Imports */

import { ArrowBack, Close, InfoOutlined } from "@mui/icons-material";
import PlayCircleOutlineOutlinedIcon from "@mui/icons-material/PlayCircleOutlineOutlined";

/* Library Function Imports */

import { TransitionProps } from "@mui/material/transitions";
import { useRouter } from "next/router";
import { security_deposit } from "../../../lib/data/search-filters";
import { property_images } from "../../../redux-magic/sub-interfaces/new-property-data-interface";

/* Styled Components */

const CustomDialog = styled(Dialog)(({ theme }) => ({
	"& .MuiDialog-paper": {
		[theme.breakpoints.down("sm")]: {
			borderRadius: "0rem",
			minHeight: "100%",
		},
		minHeight: "700px",
		maxHeight: "100%",
		borderRadius: "1rem",
		background: theme.palette.background.paper,
		position: "relative",
	},
}));

const CustomDialogTitle = styled(DialogTitle)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	fontSize: "1.25rem",
	fontWeight: 500,
	lineHeight: "106%",
	background: theme.palette.background.paper,
	gap: "0rem",
	padding: "1rem ",
	borderRadius: "1rem 1rem 0rem 0rem",
}));

const CustomDialogContent = styled(DialogContent)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	gap: "0.5rem",
	padding: "1rem",
	background: theme.palette.background.paper,
	borderRadius: "0rem 0rem 1rem 1rem",
	overflow: "scroll",
}));

const CustomDiv = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
}));

// const StepDiv = styled("div")(({ theme }) => ({
// 	display: "flex",
// 	flexDirection: "row",
// 	justifyContent: "center",
// 	alignItems: "center",
// 	borderRadius: "2.5rem",
// 	background: theme.palette.mode == "dark" ? "#FFFFFF" : "var(--Text-New-Secondary, #666)",
// 	padding: "0rem 0.5rem",
// 	gap: "0.5rem",
// 	height: "1.5rem",
// 	width: "2.25rem",
// }));

// const CustomTypography = styled(Typography)(({ theme }) => ({
// 	fontSize: "0.75rem",
// 	fontWeight: 400,
// 	color: theme.palette.mode == "dark" ? "#212121" : "#ffffff",
// 	padding: "0rem",
// }));

const PropertyNameContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	gap: "2rem",
}));

const TextContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "flex-start",
	width: "100%",
	gap: "0.25rem",
}));

const Snack = styled(Snackbar)(({ theme }) => ({
	// [theme.breakpoints.down("md")]: {
	// 	bottom: "5rem",
	// 	borderRadius: "0.5rem",
	// },
}));

const ProgressContainer = styled("div")(({ theme }) => ({
	width: "100%",
	padding: "0.75rem 0rem 0rem 0rem ",
}));

const CustomLinearProgress = styled(LinearProgress)(({ theme }) => ({
	width: "100%",
	height: "0.25rem",
	borderRadius: "1rem",
}));

const IconTitleRow = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "flex-start",
	alignItems: "center",
	gap: "0rem",
	height: "auto",
}));

/* Dialog Transition */

const DialogTransition = React.forwardRef(function Transition(
	props: TransitionProps & {
		children: React.ReactElement<any, any>;
	},
	ref: React.Ref<unknown>,
) {
	return (
		<Slide
			direction="up"
			ref={ref}
			{...props}
		/>
	);
});

const ResumeUploadContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	justifyContent: "space-between",
	alignItems: "center",
	width: "100%",
	padding: "1rem",
	borderRadius: "1rem",
	background: "#FFF7F0",
	"@media (pointer: fine)": {
		"&:hover": {
			cursor: "pointer",
		},
	},
}));

const ColumnContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	justifyContent: "center",
	alignItems: "flex-start",
	width: "100%",
}));

const SubText = styled(Typography)(({ theme }) => ({
	fontSize: "0.75rem",
	fontWeight: 400,
	lineHeight: "166%",
	letterSpacing: "0.4px",
	color: "#666666",
}));

const Text = styled(Typography)(({ theme }) => ({
	fontSize: "0.875rem",
	fontWeight: 500,
	lineHeight: "157%",
	letterSpacing: "0.1px",
}));

const DividerContainer = styled("div")(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	alignItems: "center",
	justifyContent: "center",
	gap: "8px",
	width: "100%",
	margin: "0.5rem 0rem 0.5rem 0rem",
}));

interface security_deposit {
	min: number;
	max: number;
	negotiable: boolean;
	currency: string;
}

interface Area {
	label: string;
	enableLabel: boolean;
	land_area: {
		min: { ft: number; mt: number; acre: number };
		max: { ft: number; mt: number; acre: number };
	};
	super_built_up_area: {
		min: { ft: number; mt: number; acre: number };
		max: { ft: number; mt: number; acre: number };
	};
	carpet_area: {
		min: { ft: number; mt: number; acre: number };
		max: { ft: number; mt: number; acre: number };
	};
	karab_area: {
		min: { ft: number; mt: number; acre: number };
		max: { ft: number; mt: number; acre: number };
	};
}

interface BHK {
	min: number;
	max: number;
	label: string;
	enableLabel: boolean;
}

type RequestBody = {
	is_business_profile: boolean;
	business_profile_id: string | ObjectId;
};

const CreatePropertyWithUploadTool = ({
	open,
	handleClose,
	dispatch,
	new_listing_url,
	session,
	newPropertyData,
	pathname,
	broadcastData,
	broadcastFeatureDiscoveryTracker,
	draftPropertyId,
	draftBusinessProfileId,
	onDraftSaved,
}: {
	open: boolean;
	handleClose: any;
	dispatch: Function;
	new_listing_url: StateInterface["new_listing_url"];
	session: StateInterface["redux_session"];
	newPropertyData: StateInterface["new_property_data"];
	pathname?: any;
	broadcastData: StateInterface["broadcast_data"];
	broadcastFeatureDiscoveryTracker: StateInterface["feature_discovery_tracker"]["broadcast"];
	/** Opens on this saved draft ("Continue editing" on a Listings draft card). */
	draftPropertyId?: string;
	/** The business the draft belongs to (the dashboard's); defaults to the user's first business. */
	draftBusinessProfileId?: string;
	/** Called once a draft is saved, discarded as gone, or posted, so a listings screen can reload. */
	onDraftSaved?: () => void;
}) => {
	const theme = useTheme();
	const router = React.useRef(useRouter()).current;

	/* User business profiles */

	let businessProfiles: DbUserPage | null = session
		? session.user
			? session.user.dbUser
				? session.user.dbUser.pages
					? session.user.dbUser.pages[0]
					: null
				: null
			: null
		: null;

	/* Drafts are saved to the server (lib/listings/webPropertyDraft.ts), so the app and other browsers see
	   them. draftId is the draft this wizard opened from or saved, and is posted in place on Publish. */

	const draftBusinessId: string = draftBusinessProfileId || (businessProfiles?.page_id ? String(businessProfiles.page_id) : "");

	const [draftId, setDraftId] = React.useState<string>("");

	const smDevice: boolean = useMediaQuery(theme.breakpoints.down("sm"));

	const [openSuccessModal, setOpenSuccessModal] = React.useState<boolean>(false);

	const [activeStep, setActiveStep] = React.useState(0);

	const [propertyTitle, setPropertyTitle] = React.useState<string>("");

	const [businessProfileName, setBusinessProfileName] = React.useState<string>("");

	const [businessProfileType, setBusinessProfileType] = React.useState<string>("");

	const [createBusinessProfile, setcreateBusinessProfile] = React.useState<boolean>(false);

	const [loading, setLoading] = React.useState(false);

	const [newListing, setNewListing] = React.useState<boolean>(false);

	const [loadNext, setLoadNext] = React.useState<boolean>(false);

	const [alertModal, setAlertModal] = React.useState<boolean>(false);

	const [openSnackbar, setOpenSnackbar] = React.useState(false);

	const [propertyNameError, setPropertyNameError] = React.useState<boolean>(false);

	const [businessProfileNameError, setBusinessProfileNameError] = React.useState<boolean>(false);

	const [businessProfileTypeError, setBusinessProfileTypeError] = React.useState<boolean>(false);

	const [transactionTypeError, setTransactionTypeError] = React.useState<boolean>(false);

	const [propertyCategoryError, setPropertyCategoryError] = React.useState<boolean>(false);

	const [propertyTypeError, setPropertyTypeError] = React.useState<boolean>(false);

	const [priceMinError, setPriceMinError] = React.useState<boolean>(false);

	const [priceMaxError, setPriceMaxError] = React.useState<boolean>(false);

	const [availabilityError, setAvailabilityError] = React.useState<boolean>(false);

	const [possessionDateError, setPossessionDateError] = React.useState<boolean>(false);

	const [propertyBHKminError, setPropertyBHKminError] = React.useState<boolean>(false);

	const [propertyBHKmaxError, setPropertyBHKmaxError] = React.useState<boolean>(false);

	const [propertyBathroomMinError, setPropertyBathroomMinError] = React.useState<boolean>(false);

	const [propertyBathroomMaxError, setPropertyBathroomMaxError] = React.useState<boolean>(false);

	const [propertyNoOfSeatsError, setPropertyNoOfSeatsError] = React.useState<boolean>(false);

	const [propertyNoOfUnitsError, setPropertyNoOfUnitsError] = React.useState<boolean>(false);

	const [propertyPlotDimensionsError, setPropertyPlotDimensionsError] = React.useState<boolean>(false);

	const [propertyLandAreaError, setPropertyLandAreaError] = React.useState<boolean>(false);

	const [propertySuperBuiltUpMinAreaError, setPropertySuperBuiltUpMinAreaError] = React.useState<boolean>(false);

	const [propertySuperBuiltUpMaxAreaError, setPropertySuperBuiltUpMaxAreaError] = React.useState<boolean>(false);

	const [propertyPermitNumberError, setPropertyPermitNumberError] = React.useState<boolean>(false);

	const [propertyBlnError, setPropertyBlnError] = React.useState<boolean>(false);

	// lets check if the 0th step is complete
	const stepZeroComplete: boolean =
		(activeStep != 0 && createBusinessProfile && (businessProfileName === "" || businessProfileType === "")) ||
		(businessProfiles === null && (businessProfileName === "" || businessProfileType === "")) ||
		propertyTitle === "" ||
		loading;

	// lets check if the 1st step is complete
	// Extract current location values
	const currentLatitude = newPropertyData?.search_metrics.location_coordinates[0];
	const currentLongitude = newPropertyData?.search_metrics.location_coordinates[1];

	// Extract previous location values (assuming location_data is available in scope)
	const previousLatitude = 1;
	const previousLongitude = 1;

	// Check if location value has changed

	const didLocationChange = currentLatitude !== previousLatitude || currentLongitude !== previousLongitude;

	const stepOneComplete: boolean = activeStep === 1 && !didLocationChange;

	const stepFiveCompleted: boolean = activeStep === 5 && newPropertyData?.uploading_images ? false : true;

	// activeStep === 5 && newPropertyData?.images.length > 0 && !newPropertyData?.image_upload_completed;

	const storeInLocalStorage = (
		key: any,
		data: {
			createBusinessProfile: boolean;
			propertyTitle: string;
			newPropertyData: StateInterface["new_property_data"];
			stepsCompleted: number;
		},
	) => {
		localStorage.setItem(key, JSON.stringify(data));
	};

	// lets create functions to handle the stepper

	/* "Review and post" Edit links (3 Nov 2026, the app's returnToReview): a step opened from the review goes straight
	   back to it once its own checks pass, instead of walking through the steps after it. */
	const [returnToReview, setReturnToReview] = React.useState<boolean>(false);
	const REVIEW_STEP: number = 6;
	const goForward = () => {
		if (returnToReview) {
			setReturnToReview(false);
			setActiveStep(REVIEW_STEP);
		} else {
			setActiveStep(activeStep + 1);
		}
	};

	const handleNext = () => {
		if (activeStep === 0) {
			if (
				(createBusinessProfile && (businessProfileName === "" || businessProfileType === "")) ||
				(businessProfiles === null && (businessProfileName === "" || businessProfileType === "")) ||
				propertyTitle === "" ||
				loading
			) {
				if (createBusinessProfile && businessProfileName === "") {
					setBusinessProfileNameError(true);
				}
				if (createBusinessProfile && businessProfileType === "") {
					setBusinessProfileTypeError(true);
				}
				if (propertyTitle === "") {
					setPropertyNameError(true);
				}
			} else {
				goForward();
			}
		} else if (activeStep === 1) {
			goForward();
		} else if (activeStep === 2) {
			if (
				newPropertyData?.transaction_type !== "ofb" &&
				(newPropertyData?.transaction_type === "" ||
					newPropertyData?.property_category === "" ||
					newPropertyData?.property_type?.length === 0 ||
					newPropertyData?.price?.min === 0 ||
					newPropertyData?.price?.min === null ||
					newPropertyData?.price?.max === 0 ||
					newPropertyData?.price?.max === null ||
					newPropertyData?.price?.min > newPropertyData?.price?.max ||
					(newPropertyData?.transaction_type === "rent" &&
						(newPropertyData?.property_type?.includes("Land (Residential)") ||
							newPropertyData?.property_type?.includes("Land (Commercial)") ||
							newPropertyData?.property_type?.includes("Land (Agricultural)") ||
							newPropertyData?.property_type?.includes("Land (Industrial)") ||
							newPropertyData?.property_type?.includes("Mining")) &&
						newPropertyData?.availability?.length === 0) ||
					(!newPropertyData?.property_type?.includes("Land (Residential)") &&
						!newPropertyData?.property_type?.includes("Land (Commercial)") &&
						!newPropertyData?.property_type?.includes("Land (Agricultural)") &&
						!newPropertyData?.property_type?.includes("Land (Industrial)") &&
						!newPropertyData?.property_type?.includes("Mining") &&
						newPropertyData?.availability?.length === 0) ||
					((newPropertyData?.availability?.includes("Under construction") ||
						newPropertyData?.availability?.includes("under_construction") ||
						newPropertyData?.availability?.includes("Select date") ||
						newPropertyData?.availability?.includes("select_date")) &&
						newPropertyData?.possession_date === ""))
			) {
				if (newPropertyData && newPropertyData.transaction_type === "") {
					setTransactionTypeError(true);
				}
				if (newPropertyData && newPropertyData.property_category === "") {
					setPropertyCategoryError(true);
				}
				if (newPropertyData && newPropertyData.property_type.length === 0) {
					setPropertyTypeError(true);
				}
				if (newPropertyData && newPropertyData.price.min === 0) {
					setPriceMinError(true);
				}
				if (newPropertyData && newPropertyData.price.max === 0) {
					setPriceMaxError(true);
				}
				if (
					newPropertyData.transaction_type === "rent" &&
					(newPropertyData?.property_type?.includes("Land (Residential)") ||
						newPropertyData?.property_type?.includes("Land (Commercial)") ||
						newPropertyData?.property_type?.includes("Land (Agricultural)") ||
						newPropertyData?.property_type?.includes("Land (Industrial)") ||
						newPropertyData?.property_type?.includes("Mining")) &&
					newPropertyData?.availability?.length === 0
				) {
					setAvailabilityError(true);
				}
				if (
					!newPropertyData?.property_type?.includes("Land (Residential)") &&
					!newPropertyData?.property_type?.includes("Land (Commercial)") &&
					!newPropertyData?.property_type?.includes("Land (Agricultural)") &&
					!newPropertyData?.property_type?.includes("Land (Industrial)") &&
					!newPropertyData?.property_type?.includes("Mining") &&
					newPropertyData?.availability?.length === 0
				) {
					setAvailabilityError(true);
				}
				if (
					(newPropertyData?.availability?.includes("Under construction") ||
						newPropertyData?.availability?.includes("under_construction") ||
						newPropertyData?.availability?.includes("Select date") ||
						newPropertyData?.availability?.includes("select_date")) &&
					newPropertyData?.possession_date === ""
				) {
					setPossessionDateError(true);
				}
			} else {
				goForward();
			}
		} else if (activeStep === 3) {
			const isAbuDhabiStep3 =
				(newPropertyData?.location?.country || "").toLowerCase() === "united arab emirates" &&
				(newPropertyData?.location?.state_or_province || "").toLowerCase() === "abu dhabi";
			/* Required of every creator in Abu Dhabi, as on the apps (decided 1 Nov 2026). */
			const permitSectionInvalid =
				isAbuDhabiStep3 &&
				(!newPropertyData?.regulatory_permit?.permit_number || !newPropertyData?.broker_license?.permit_number);
			if (
				permitSectionInvalid ||
				(!newPropertyData?.property_type.includes("Plot") &&
					!newPropertyData?.property_type.includes("Farm Plot") &&
					!newPropertyData?.property_type.includes("Plot (Commercial)") &&
					!newPropertyData?.property_type.includes("Land (Residential)") &&
					!newPropertyData?.property_type.includes("Land (Commercial)") &&
					!newPropertyData?.property_type.includes("Land (Agricultural)") &&
					!newPropertyData?.property_type.includes("Land (Industrial)") &&
					!newPropertyData?.property_type.includes("Studio Apartment") &&
					!newPropertyData?.property_type.includes("Building (Commercial)") &&
					!newPropertyData?.property_type.includes("Building (Residential)") &&
					!newPropertyData?.property_type.includes("Shop") &&
					!newPropertyData?.property_type.includes("Office Space") &&
					!newPropertyData?.property_type.includes("Co-working") &&
					!newPropertyData?.property_type.includes("Warehouse") &&
					!newPropertyData?.property_type.includes("Factory") &&
					!newPropertyData?.property_type.includes("Mining") &&
					(newPropertyData?.bhk.min === 0 ||
						newPropertyData?.bhk.min === undefined ||
						newPropertyData?.bhk.max === 0 ||
						newPropertyData?.bhk.max === null ||
						newPropertyData?.bhk.min > newPropertyData?.bhk?.max)) ||
				/* Bathrooms */

				newPropertyData?.bathroom?.min > newPropertyData?.bathroom?.max ||
				/* No. of seats */

				(newPropertyData?.property_type.includes("Co-working") &&
					(newPropertyData?.no_of_seats.max === 0 || newPropertyData?.no_of_seats.max === null)) ||
				/* No. of units */

				(((newPropertyData?.transaction_type === "buy" && newPropertyData?.property_type.includes("Apartment")) ||
					(newPropertyData?.transaction_type === "buy" && newPropertyData?.property_type.includes("Plot")) ||
					(newPropertyData?.transaction_type === "buy" && newPropertyData?.property_type.includes("Farm Plot")) ||
					(newPropertyData?.transaction_type === "buy" &&
						newPropertyData?.property_type.includes("Plot (Commercial)")) ||
					(newPropertyData?.transaction_type === "buy" && newPropertyData?.property_type.includes("Villa")) ||
					(newPropertyData?.transaction_type === "buy" && newPropertyData?.property_type.includes("Row House")) ||
					(newPropertyData?.transaction_type === "buy" &&
						newPropertyData?.property_type.includes("Builder Floor Apartment")) ||
					(newPropertyData?.transaction_type === "buy" &&
						newPropertyData?.property_type.includes("Building (Residential)")) ||
					(newPropertyData?.transaction_type === "buy" &&
						newPropertyData?.property_type.includes("Studio Apartment")) ||
					(newPropertyData?.transaction_type === "buy" && newPropertyData?.property_type.includes("Penthouse")) ||
					(newPropertyData?.transaction_type === "rent" &&
						newPropertyData?.property_type.includes("Building (Residential)")) ||
					(newPropertyData?.transaction_type === "resale" &&
						newPropertyData?.property_type.includes("Building (Residential)"))) &&
					(newPropertyData?.no_of_units.max === 0 || newPropertyData?.no_of_units.max === null)) ||
				/* Plot Dimensions */

				((newPropertyData?.property_type.includes("Plot") ||
					newPropertyData?.property_type.includes("Farm Plot") ||
					newPropertyData?.property_type.includes("Plot (Commercial)")) &&
					newPropertyData?.plot_dimensions.length === 0) ||
				/* Land Area (a cleared field holds NaN, so anything not above 0 is missing) */

				((newPropertyData?.transaction_type == "buy" ||
					(newPropertyData?.transaction_type == "rent" &&
						(newPropertyData?.property_type.includes("Land (Residential)") ||
							newPropertyData?.property_type.includes("Land (Commercial)") ||
							newPropertyData?.property_type.includes("Land (Agricultural)") ||
							newPropertyData?.property_type.includes("Land (Industrial)") ||
							newPropertyData.property_type.includes("Mining")))) &&
					!((newPropertyData?.area.land_area.max.acre ?? 0) > 0)) ||
				/* Super Built Up Area */

				(((newPropertyData?.transaction_type == "buy" &&
					newPropertyData?.property_type.includes("Independent House")) ||
					(newPropertyData?.transaction_type == "buy" && newPropertyData?.property_type.includes("Co-living/PG")) ||
					(newPropertyData?.transaction_type == "buy" &&
						newPropertyData?.property_type.includes("Building (Commercial)")) ||
					(newPropertyData?.transaction_type == "buy" &&
						newPropertyData?.property_type.includes("Building (Residential)")) ||
					(newPropertyData?.transaction_type == "buy" && newPropertyData?.property_type.includes("Shop")) ||
					(newPropertyData?.transaction_type == "buy" && newPropertyData?.property_type.includes("Office Space")) ||
					(newPropertyData?.transaction_type == "buy" && newPropertyData?.property_type.includes("Co-working")) ||
					(newPropertyData?.transaction_type == "buy" && newPropertyData?.property_type.includes("Warehouse")) ||
					(newPropertyData?.transaction_type == "buy" && newPropertyData?.property_type.includes("Factory")) ||
					(newPropertyData?.transaction_type == "rent" &&
						newPropertyData?.property_type.includes("Independent House")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Apartment")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Villa")) ||
					(newPropertyData?.transaction_type == "rent" &&
						newPropertyData?.property_type.includes("Builder Floor Apartment")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Penthouse")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Row House")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Plot")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Farm Plot")) ||
					(newPropertyData?.transaction_type == "rent" &&
						newPropertyData?.property_type.includes("Plot (Commercial)")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Farm House")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Warehouse")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Factory")) ||
					(newPropertyData?.transaction_type == "rent" &&
						newPropertyData?.property_type.includes("Building (Commercial)")) ||
					(newPropertyData?.transaction_type == "rent" &&
						newPropertyData?.property_type.includes("Building (Residential)")) ||
					(newPropertyData?.transaction_type == "rent" && newPropertyData?.property_type.includes("Shop")) ||
					(newPropertyData?.transaction_type == "resale" &&
						newPropertyData?.property_type.includes("Independent House")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Co-living/PG")) ||
					(newPropertyData?.transaction_type == "resale" &&
						newPropertyData?.property_type.includes("Building (Commercial)")) ||
					(newPropertyData?.transaction_type == "resale" &&
						newPropertyData?.property_type.includes("Building (Residential)")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Shop")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Office Space")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Co-working")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Plot")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Farm Plot")) ||
					(newPropertyData?.transaction_type == "resale" &&
						newPropertyData?.property_type.includes("Plot (Commercial)")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Farm House")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Warehouse")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Apartment")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Villa")) ||
					(newPropertyData?.transaction_type == "resale" &&
						newPropertyData?.property_type.includes("Builder Floor Apartment")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Penthouse")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Row House")) ||
					(newPropertyData?.transaction_type == "resale" && newPropertyData?.property_type.includes("Factory"))) &&
					(newPropertyData?.area.super_built_up_area.min.ft === 0 ||
						newPropertyData?.area.super_built_up_area.min.ft === null ||
						newPropertyData?.area.super_built_up_area.max.ft === 0 ||
						newPropertyData?.area.super_built_up_area.max.ft === null ||
						newPropertyData?.area.super_built_up_area.min.ft > newPropertyData?.area.super_built_up_area.max.ft))
			) {
				if (
					!newPropertyData?.property_type.includes("Plot") &&
					!newPropertyData?.property_type.includes("Farm Plot") &&
					!newPropertyData?.property_type.includes("Plot (Commercial)") &&
					!newPropertyData?.property_type.includes("Land (Residential)") &&
					!newPropertyData?.property_type.includes("Land (Commercial)") &&
					!newPropertyData?.property_type.includes("Land (Agricultural)") &&
					!newPropertyData?.property_type.includes("Land (Industrial)") &&
					!newPropertyData?.property_type.includes("Studio Apartment") &&
					!newPropertyData?.property_type.includes("Building (Commercial)") &&
					!newPropertyData?.property_type.includes("Building (Residential)") &&
					!newPropertyData?.property_type.includes("Shop") &&
					!newPropertyData?.property_type.includes("Office Space") &&
					!newPropertyData?.property_type.includes("Co-working") &&
					!newPropertyData?.property_type.includes("Warehouse") &&
					!newPropertyData?.property_type.includes("Factory") &&
					!newPropertyData?.property_type.includes("Mining") &&
					(newPropertyData?.bhk.min === 0 ||
						newPropertyData?.bhk.min === undefined ||
						newPropertyData?.bhk.max === 0 ||
						newPropertyData?.bhk.max === null)
				) {
					if (newPropertyData?.bhk.min === 0 || newPropertyData?.bhk.min === undefined) {
						setPropertyBHKminError(true);
					}
					if (newPropertyData?.bhk.max === 0 || newPropertyData?.bhk.max === null) {
						setPropertyBHKmaxError(true);
					}
					setPropertyBHKmaxError(true);
					if (newPropertyData.bathroom.min === 0 || newPropertyData.bathroom.min === undefined) {
						setPropertyBathroomMinError(true);
					}
					if (newPropertyData.bathroom.max === 0 || newPropertyData.bathroom.max === null) {
						setPropertyBathroomMaxError(true);
					}
					setPropertyBathroomMaxError(true);
				}
				if (
					newPropertyData?.property_type.includes("Co-working") &&
					(newPropertyData?.no_of_seats.max === 0 || newPropertyData?.no_of_seats.max === null)
				) {
					setPropertyNoOfSeatsError(true);
				}
				if (
					(newPropertyData?.transaction_type === "buy" &&
						(newPropertyData?.property_type.includes("Apartment") ||
							newPropertyData?.property_type.includes("Plot") ||
							newPropertyData?.property_type.includes("Farm Plot") ||
							newPropertyData?.property_type.includes("Plot (Commercial)") ||
							newPropertyData?.property_type.includes("Villa") ||
							newPropertyData?.property_type.includes("Row House") ||
							newPropertyData?.property_type.includes("Builder Floor Apartment") ||
							newPropertyData?.property_type.includes("Building (Residential)") ||
							newPropertyData?.property_type.includes("Studio Apartment") ||
							newPropertyData?.property_type.includes("Penthouse")) &&
						(newPropertyData?.no_of_units.max === 0 || newPropertyData?.no_of_units.max === null)) ||
					(newPropertyData?.transaction_type === "rent" &&
						newPropertyData?.property_type.includes("Building (Residential)") &&
						(newPropertyData?.no_of_units.max === 0 || newPropertyData?.no_of_units.max === null)) ||
					(newPropertyData?.transaction_type === "resale" &&
						newPropertyData?.property_type.includes("Building (Residential)") &&
						(newPropertyData?.no_of_units.max === 0 || newPropertyData?.no_of_units.max === null))
				) {
					setPropertyNoOfUnitsError(true);
				}
				if (
					(newPropertyData?.property_type.includes("Plot") ||
						newPropertyData?.property_type.includes("Farm Plot") ||
						newPropertyData?.property_type.includes("Plot (Commercial)")) &&
					newPropertyData?.plot_dimensions.length === 0
				) {
					setPropertyPlotDimensionsError(true);
				}

				if (
					(newPropertyData.transaction_type == "buy" &&
						!((newPropertyData.area.land_area.max.acre ?? 0) > 0)) ||
					(newPropertyData?.transaction_type == "rent" &&
						(newPropertyData?.property_type.includes("Land (Residential)") ||
							newPropertyData?.property_type.includes("Land (Commercial)") ||
							newPropertyData?.property_type.includes("Land (Agricultural)") ||
							newPropertyData?.property_type.includes("Land (Industrial)") ||
							newPropertyData.property_type.includes("Mining")) &&
						!((newPropertyData?.area.land_area.max.acre ?? 0) > 0))
				) {
					setPropertyLandAreaError(true);
				}

				if (
					((newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Independent House")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Apartment")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Co-living/PG")) ||
						(newPropertyData.transaction_type == "buy" &&
							newPropertyData.property_type.includes("Building (Commercial)")) ||
						(newPropertyData.transaction_type == "buy" &&
							newPropertyData.property_type.includes("Building (Residential)")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Shop")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Office Space")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Co-working")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Warehouse")) ||
						(newPropertyData.transaction_type == "buy" && newPropertyData.property_type.includes("Factory")) ||
						(newPropertyData.transaction_type == "rent" &&
							newPropertyData.property_type.includes("Independent House")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Apartment")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Villa")) ||
						(newPropertyData.transaction_type == "rent" &&
							newPropertyData.property_type.includes("Builder Floor Apartment")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Penthouse")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Row House")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Plot")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Farm Plot")) ||
						(newPropertyData.transaction_type == "rent" &&
							newPropertyData.property_type.includes("Plot (Commercial)")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Farm House")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Warehouse")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Factory")) ||
						(newPropertyData.transaction_type == "rent" &&
							newPropertyData.property_type.includes("Building (Commercial)")) ||
						(newPropertyData.transaction_type == "rent" &&
							newPropertyData.property_type.includes("Building (Residential)")) ||
						(newPropertyData.transaction_type == "rent" && newPropertyData.property_type.includes("Shop")) ||
						(newPropertyData.transaction_type == "resale" &&
							newPropertyData.property_type.includes("Independent House")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Co-living/PG")) ||
						(newPropertyData.transaction_type == "resale" &&
							newPropertyData.property_type.includes("Building (Commercial)")) ||
						(newPropertyData.transaction_type == "resale" &&
							newPropertyData.property_type.includes("Building (Residential)")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Shop")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Office Space")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Co-working")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Plot")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Farm Plot")) ||
						(newPropertyData.transaction_type == "resale" &&
							newPropertyData.property_type.includes("Plot (Commercial)")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Farm House")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Warehouse")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Apartment")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Villa")) ||
						(newPropertyData.transaction_type == "resale" &&
							newPropertyData.property_type.includes("Builder Floor Apartment")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Penthouse")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Row House")) ||
						(newPropertyData.transaction_type == "resale" && newPropertyData.property_type.includes("Factory"))) &&
					(newPropertyData?.area.super_built_up_area.min.ft === 0 ||
						newPropertyData?.area.super_built_up_area.min.ft === null ||
						newPropertyData?.area.super_built_up_area.max.ft === 0 ||
						newPropertyData?.area.super_built_up_area.max.ft === null ||
						(newPropertyData?.area.super_built_up_area.min.ft !== 0 &&
							newPropertyData?.area.super_built_up_area.max.ft !== 0 &&
							newPropertyData?.area.super_built_up_area.min.ft > newPropertyData?.area.super_built_up_area.max.ft) ||
						isNaN(newPropertyData?.area.super_built_up_area.min.ft) ||
						isNaN(newPropertyData?.area.super_built_up_area.max.ft))
				) {
					if (
						newPropertyData?.area.super_built_up_area.min.ft === 0 ||
						newPropertyData?.area.super_built_up_area.min.ft === null
					) {
						setPropertySuperBuiltUpMinAreaError(true);
					}
					if (
						newPropertyData?.area.super_built_up_area.max.ft === 0 ||
						newPropertyData?.area.super_built_up_area.max.ft === null
					) {
						setPropertySuperBuiltUpMaxAreaError(true);
					}
					setPropertySuperBuiltUpMaxAreaError(true);
				}
				if (permitSectionInvalid) {
					if (!newPropertyData?.regulatory_permit?.permit_number) {
						setPropertyPermitNumberError(true);
					}
					if (!newPropertyData?.broker_license?.permit_number) {
						setPropertyBlnError(true);
					}
				}
			} else {
				goForward();
			}
		} else if (activeStep === 4) {
			goForward();
		} else if (activeStep === 5) {
			goForward();
		}

		//  Let's store the existing data in local storage

		storeInLocalStorage("create_property_data", {
			createBusinessProfile: createBusinessProfile,
			propertyTitle: propertyTitle,
			newPropertyData: newPropertyData,
			stepsCompleted: activeStep + 1,
		});
	};

	// Resume upload function

	let previousData: {
		createBusinessProfile: boolean;
		propertyTitle: string;
		newPropertyData: StateInterface["new_property_data"];
		stepsCompleted: number;
	} | null = null;

	if (typeof window !== "undefined") {
		previousData = JSON.parse(localStorage.getItem("create_property_data") || "{}");
	}

	const handleSetPreviousData = () => {
		setcreateBusinessProfile(previousData?.createBusinessProfile || false);
		setPropertyTitle(previousData?.propertyTitle || "");
		setActiveStep(previousData?.stepsCompleted || 0);
		dispatch(setPreviousPropertyDataThunk(previousData ? previousData.newPropertyData : null));
	};

	/* Continue editing: load the draft into the form and open it at its first unfinished step. A draft
	   that is gone (discarded or posted elsewhere) closes the wizard and lets the screen reload. */

	React.useEffect(() => {
		if (!open || !draftPropertyId || !draftBusinessId) return;
		let cancelled = false;
		setLoadNext(true);
		fetchWebPropertyDraft(draftBusinessId, draftPropertyId).then((draft) => {
			if (cancelled) return;
			setLoadNext(false);
			if (!draft) {
				handleClose();
				onDraftSaved?.();
				return;
			}
			setcreateBusinessProfile(false);
			setPropertyTitle(draft.property_name || "");
			dispatch(setPreviousPropertyDataThunk(draftToNewPropertyData(draft)));
			setDraftId(draftPropertyId);
			setActiveStep(draftResumeStep(draft));
		});
		return () => {
			cancelled = true;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open, draftPropertyId]);

	const handleBack = () => {
		setActiveStep(activeStep - 1);
	};

	/* Create new property function */

	const propertyImageObject = newPropertyData?.images.map((image: property_images) => {
		return {
			file_id: image.file_id,
			mime_type: image.mime_type,
			category: image.category,
			caption: image.caption,
			priority: image.priority,
		};
	});

	const handleClickCreateNewProperty = async () => {
		setLoading(true);
		(setNewListing(true), setLoadNext(true));
		const created = await dispatch(
			createNewPropertyWithUploadToolThunk({
				createNewBusinessProfile: createBusinessProfile,
				/* A draft is posted on the business it was saved for. */
				businessProfileId: createBusinessProfile ? "" : draftId ? draftBusinessId : businessProfiles?.page_id || "",
				creatorIsBusinessProfile: true,
				businessProfileName: createBusinessProfile ? businessProfileName : businessProfiles?.page_title || "",
				businessProfileType: createBusinessProfile
					? businessProfileType.toLowerCase()
					: businessProfiles?.page_type || "",
				userId: session?.user?.dbUser?._id || "",
				phoneNumber: session?.user?.dbUser?.phone || "",
				countryCode: session?.user?.dbUser?.country_code || "",
				propertyName: propertyTitle,
				propertyLocationName: newPropertyData?.location.title,
				propertyLocationCoordinates: newPropertyData?.search_metrics.location_coordinates,
				propertyCountry: newPropertyData?.location.country || "",
				propertyStateOrProvince: newPropertyData?.location.state_or_province || "",
				propertyCity: newPropertyData?.location.city || "",
				propertyTransactionType: newPropertyData?.transaction_type,
				propertyCategory: newPropertyData?.property_category,
				propertyType: newPropertyData?.property_type,
				propertySubtype: newPropertyData?.property_subtype,
				propertyMinPrice: newPropertyData?.price.min,
				propertyMaxPrice: newPropertyData?.price.max,
				propertyCurrency: newPropertyData?.price.currency,
				propertyRegulatoryPermit: {
					permit_number: newPropertyData?.regulatory_permit?.permit_number || "",
					issuing_authority: newPropertyData?.regulatory_permit?.issuing_authority || "",
				},
				brokerLicense: {
					permit_number: newPropertyData?.broker_license?.permit_number || "",
					permit_name: newPropertyData?.broker_license?.permit_name || "",
				},
				propertySecurityDeposit: newPropertyData?.security_deposit.max,
				propertyStatus: newPropertyData?.availability[0]?.toLowerCase().replace(/\s+/g, "_"),
				propertyPossessionDate: newPropertyData?.possession_date,
				propertyAge: newPropertyData?.property_age,
				propertyFacing: newPropertyData?.unit_facing,
				propertyFurnishing: newPropertyData?.furnished,
				propertyMinBedrooms: newPropertyData?.bhk.min,
				propertyMaxBedrooms: newPropertyData?.bhk.max,
				propertyMinBathrooms: newPropertyData?.bathroom.min,
				propertyMaxBathroom: newPropertyData?.bathroom.max,
				propertyNoOfBalconies: newPropertyData?.balconies.max,
				propertyNoOfSeats: newPropertyData?.no_of_seats.max,
				propertyNoOfUnits: newPropertyData?.no_of_units.max,
				propertyNoOfFloors: newPropertyData?.floors.max,
				propertyPlotDimensions: newPropertyData?.plot_dimensions,
				propertyLandAreaUnit: newPropertyData?.area.land_area.land_area_unit,
				propertyLandArea: newPropertyData?.area.land_area.max.acre,
				propertySuperBuiltUpAreaUnit: newPropertyData?.area.super_built_up_area.super_built_up_area_unit,
				propertyMinSuperBuiltUpArea: newPropertyData?.area.super_built_up_area.min.ft,
				propertyMaxSuperBuiltUpArea: newPropertyData?.area.super_built_up_area.max.ft,
				propertyIsCarpetAreaPercentage: true,
				propertyCarpetAreaPercentage: "0",
				propertyCarpetAreaUnit: newPropertyData?.area.carpet_area.carpet_area_unit,
				propertyMinCarpetArea: newPropertyData?.area.carpet_area.min.ft,
				propertyMaxCarpetArea: newPropertyData?.area.carpet_area.max.ft,
				propertyImages: propertyImageObject,
				propertyOverview: newPropertyData?.description,
				sessionId: session ? (session.session_id ? session.session_id : "") : "",
				locale: (router.locale as string) || "en-IN",
				draftPropertyId: draftId || undefined,
			}),
		);

		/* A failed create: stop the spinner, show the error, and keep the form (and its draft) so the
		   person can try again. The spinner used to stay on, since only a new listing turned it off. */
		if (!created?.ok) {
			setLoading(false);
			setLoadNext(false);
			setNewListing(false);
			setOpenSnackbar(true);
			return;
		}

		if (draftId) {
			setDraftId("");
			onDraftSaved?.();
		}

		(pathname && pathname.query && pathname.query.agent_post_property_button === "true") ||
		(pathname && pathname.query && pathname.query.builder_post_property_button === "true") ||
		(pathname && pathname.query && pathname.query.landowner_post_property_button === "true")
			? router.push((process.env.PRODUCTION_URL || " ") + "/intro")
			: "";

		// Let's empty the local storage after the property is created

		localStorage.removeItem("create_property_data");
	};

	const currentPage: String = newPropertyData ? newPropertyData.currentPage : "";
	const propertyCreator: string = session
		? session.user
			? session.user.dbUser
				? session.user.dbUser.pages
					? session.user.dbUser.pages.length > 0
						? session.user.dbUser.pages[0].page_slug
						: ""
					: ""
				: ""
			: ""
		: "";

	// React.useEffect(() => {
	// 	const businessType: string = createBusinessProfile
	// 		? businessProfileType.toLowerCase()
	// 		: businessProfiles?.page_type || "";
	// 	if (
	// 		new_listing_url !== undefined &&
	// 		new_listing_url !== "" &&
	// 		newListing &&
	// 		(currentPage === "navbar" || createBusinessProfile || currentPage !== propertyCreator)
	// 	) {
	// 		// handleModalClose();
	// 		window.location.replace(`/${businessType}s/${new_listing_url}?screen=listings`);
	// 	} else if (
	// 		new_listing_url !== undefined &&
	// 		new_listing_url !== "" &&
	// 		newListing &&
	// 		currentPage === propertyCreator
	// 	) {
	// 		handleModalClose();
	// 	}
	// 	/* eslint-disable-next-line react-hooks/exhaustive-deps*/
	// }, [new_listing_url]);

	React.useEffect(() => {
		if (newPropertyData?._id !== undefined && newPropertyData?._id !== null && newPropertyData?._id !== "") {
			setLoadNext(false);
			setActiveStep(7);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [new_listing_url]);

	React.useEffect(() => {
		const businessProfilesCount = session
			? session.user
				? session.user.dbUser
					? session.user.dbUser.business_profiles_count
						? session.user.dbUser.business_profiles_count
						: 0
					: 0
				: 0
			: 0;

		if (businessProfilesCount === 0) {
			setcreateBusinessProfile(true);
		} else {
			setcreateBusinessProfile(false);
		}
	}, [session]);

	/* [discard]: leave without keeping what was typed (3 Nov 2026, the app's Discard): no draft is saved and the browser
	   copy is dropped; a draft opened from Listings keeps what it had. */
	const handleModalClose = (discard: boolean = false) => {
		setcreateBusinessProfile(false);
		setBusinessProfileName("");
		setBusinessProfileType("");
		setPropertyTitle("");
		setLoading(false);
		setLoadNext(false);
		handleClose();
		setActiveStep(0);
		setReturnToReview(false);
		dispatch(
			setCreateNewPropertyDefaultLocationThunk({
				location_coordinates: [1, 1],
				address: "",
				country: "",
				state_or_province: "",
				city: "",
			}),
		);
		dispatch(setCreateNewPropertyTransactionTypeThunk(""));
		dispatch(setCreateNewPropertyTypeThunk([""]));
		dispatch(setCreateNewPropertySubTypeThunk(""));
		dispatch(setCreateNewPropertyMinPriceThunk(0));
		dispatch(setCreateNewPropertyMaxPriceThunk(0));
		dispatch(setCreateNewPropertySecurityDepositThunk(0));
		dispatch(setCreateNewPropertyAvailabiltyThunk([""]));
		dispatch(setCreateNewePropertyPossessionDateThunk(""));
		dispatch(setCreateNewPropertyUnitFacingThunk([""]));
		dispatch(setCreateNewPropertyLandFacingThunk([""]));
		dispatch(setCreateNewPropertyAgeThunk(0));
		dispatch(setCreateNewPropertyPlotDimensionsThunk([]));
		dispatch(setCreateNewPropertyFurnishingThunk([""]));
		dispatch(setCreateNewPropertyLandAreaThunk(0));
		dispatch(setCreateNewPropertyLandAreaUnitThunk("acre"));
		dispatch(setCreateNewPropertyMaxBalconiesThunk(0));
		dispatch(setCreateNewPropertyMaxBathroomsThunk(0));
		dispatch(setCreateNewPropertyMaxBedroomsThunk(0));
		dispatch(setCreateNewPropertyMaxCarpetAreaThunk(0));
		dispatch(setCreateNewPropertyMaxFloorsThunk(0));
		dispatch(setCreateNewPropertyMaxSuperBuiltUpAreaThunk(0));
		dispatch(setCreateNePropertyMinBalconiesThunk(0));
		dispatch(setCreateNewPropertyMinBathroomsThunk(0));
		dispatch(setCreateNewPropertyMinBedroomsThunk(0));
		dispatch(setCreateNewPropertyMinCarpetAreaThunk(0));
		dispatch(setCreateNewPropertyMinSuperBuiltUpAreaThunk(0));
		dispatch(setCreateNewPropertyNoOfUnitsThunk(0));
		dispatch(setCreateNewPropertyNoOfSeatsThunk(0));
		dispatch(setCreateNewPropertyFloorNoThunk(0));
		dispatch(setCreateNewPropertySuperBuiltUpAreaUnitThunk("sqft"));
		dispatch(setCreateNewPropertyOverviewThunk(""));
		dispatch(setCreateNewPropertyUploadImagesThunk([]));
		dispatch(setPropertyImagesUploadCompletedThunk(false));
		// dispatch(setCreatePropertySelectedImagesUrlThunk([]));
		setAlertModal(false);
		setBusinessProfileNameError(false);
		setBusinessProfileTypeError(false);
		setTransactionTypeError(false);
		setPropertyNameError(false);
		setPropertyCategoryError(false);
		setPropertyTypeError(false);
		setPriceMinError(false);
		setPriceMaxError(false);
		setAvailabilityError(false);
		setPossessionDateError(false);
		setPropertyBHKminError(false);
		setPropertyBHKmaxError(false);
		setPropertyBathroomMinError(false);
		setPropertyBathroomMaxError(false);
		setPropertyNoOfSeatsError(false);
		setPropertyNoOfUnitsError(false);
		setPropertyPlotDimensionsError(false);
		setPropertyLandAreaError(false);
		setPropertySuperBuiltUpMinAreaError(false);
		setPropertySuperBuiltUpMaxAreaError(false);
		if (discard) {
			localStorage.removeItem("create_property_data");
		} else if (activeStep > 0 && activeStep < 7) {
			const browserCopy = {
				createBusinessProfile: createBusinessProfile,
				propertyTitle: propertyTitle,
				newPropertyData: newPropertyData,
				stepsCompleted: activeStep,
			};

			/* For an existing business the part-filled form is saved as a server draft (shown under Unlisted,
			   on the website and in the app), and the browser copy is dropped so the same listing can't be
			   resumed twice. A new business has nothing to save a draft against yet, so it keeps the browser
			   copy, as does a draft that fails to save. */

			if (!createBusinessProfile && draftBusinessId && propertyTitle.trim() !== "" && newPropertyData) {
				localStorage.removeItem("create_property_data");
				saveWebPropertyDraft(
					newPropertyDataToDraftBody(newPropertyData, propertyTitle.trim(), draftBusinessId, draftId),
				).then((savedId) => {
					if (savedId) {
						onDraftSaved?.();
					} else {
						storeInLocalStorage("create_property_data", browserCopy);
					}
				});
			} else {
				storeInLocalStorage("create_property_data", browserCopy);
			}
		}
		setDraftId("");
	};

	/* Closes the wizard (kept as a draft, or discarded), then the intro page's own return. */
	const closeWizard = (discard: boolean) => {
		setAlertModal(false);
		handleModalClose(discard);
		/* Post property Button (intro page) */
		if (
			(pathname && pathname.query && pathname.query.agent_post_property_button === "true") ||
			(pathname && pathname.query && pathname.query.builder_post_property_button === "true") ||
			(pathname && pathname.query && pathname.query.landowner_post_property_button === "true")
		) {
			router.push((process.env.PRODUCTION_URL || " ") + "/intro");
		}
	};

	const localLang = {
		createNewBP:
			router.locale === "ar-AE"
				? "لنقم بإنشاء ملف عمل جديد لنشر عقارك."
				: router.locale === "kn-IN"
					? "ನಿಮ್ಮ  ಆಸ್ತಿಯನ್ನು ಪೋಸ್ಟ್ ಮಾಡಲು ಹೊಸ ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ರಚಿಸೋಣ"
					: "Let's create a new business profile to post your property",
		createNewBPSubTest:
			router.locale === "ar-AE"
				? "بمجرد إنشائه، لا يمكنك تغيير اسم العقار"
				: router.locale === "kn-IN"
					? "ಒಮ್ಮೆ ರಚಿಸಿದ ನಂತರ, ನೀವು ಆಸ್ತಿಯ ಹೆಸರನ್ನು ಬದಲಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ"
					: "Once created, you cannot change the property name",
		businessName:
			router.locale === "ar-AE" ? "اسم العمل*" : router.locale === "kn-IN" ? "ವ್ಯವಹಾರದ ಹೆಸರು*" : "Business name*",
		businessNameHelperText:
			router.locale === "ar-AE"
				? "اسم العمل لا يمكن أن يكون فارغًا."
				: router.locale === "kn-IN"
					? "ವ್ಯವಹಾರದ ಹೆಸರು ಖಾಲಿಯಾಗಿರಬಾರದು"
					: "Business name cannot be empty",
		businessProfileType:
			router.locale === "ar-AE"
				? "نوع ملف العمل*"
				: router.locale === "kn-IN"
					? "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಪ್ರಕಾರ*"
					: "Business profile type*",
		agent: router.locale === "ar-AE" ? "وكلاء العقارات" : router.locale === "kn-IN" ? "ಏಜೆಂಟ್" : "Agent",
		developper: router.locale === "ar-AE" ? "المطور" : router.locale === "kn-IN" ? "ಡೆವೆಲಪರ್" : "Builder",
		landOwner: router.locale === "ar-AE" ? "مالك الأرض" : router.locale === "kn-IN" ? "ಭೂಮಾಲೀಕ" : "Owner",
		BPTypeCannotBeEmpty:
			router.locale === "ar-AE"
				? "نوع ملف العمل لا يمكن أن يكون فارغًا."
				: router.locale === "kn-IN"
					? "ವ್ಯವಹಾರ ಪ್ರೊಫೈಲ್ ಪ್ರಕಾರ ಖಾಲಿಯಾಗಿರಬಾರದು"
					: "Business profile type cannot be empty",
		enterNamePfTHeProperty:
			router.locale === "ar-AE"
				? "أدخل اسم العقار الخاص بك"
				: router.locale === "kn-IN"
					? "ನಿಮ್ಮ ಆಸ್ತಿಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ"
					: "Enter the name of your property",
		propertyNameCannotBeChanged:
			router.locale === "ar-AE"
				? "بمجرد الإنشاء، لا يمكنك تغيير اسم العقار."
				: router.locale === "kn-IN"
					? "ಒಮ್ಮೆ ರಚಿಸಿದ ನಂತರ, ನೀವು ಆಸ್ತಿಯ ಹೆಸರನ್ನು ಬದಲಾಯಿಸಲು ಸಾಧ್ಯವಿಲ್ಲ"
					: "Once created, you cannot change the property name",
		propertyName:
			router.locale === "ar-AE" ? "اسم العقار*" : router.locale === "kn-IN" ? "ಆಸ್ತಿಯ ಹೆಸರು*" : "Property name*",
		enterPropName:
			router.locale === "ar-AE"
				? "أدخل اسم العقار"
				: router.locale === "kn-IN"
					? "ಆಸ್ತಿಯ ಹೆಸರನ್ನು ನಮೂದಿಸಿ*"
					: "Enter property name",
		propNameCannotBeEmpty:
			router.locale === "ar-AE"
				? "لا يمكن أن يكون اسم العقار فارغًا"
				: router.locale === "kn-IN"
					? "ಆಸ್ತಿಯ ಹೆಸರು ಖಾಲಿಯಾಗಿರಬಾರದು"
					: "Property name cannot be empty",
		postingAs:
			router.locale === "ar-AE" ? "النشر كـ :" : router.locale === "kn-IN" ? " ಪೋಸ್ಟ್ ಮಾಡಲಾಗುತ್ತಿದೆ :" : "Posting as :",
		closePropertUpload:
			router.locale === "ar-AE"
				? "هل ترغب في إلغاء تحميل العقار؟"
				: router.locale === "kn-IN"
					? "ಸ್ಥಳದ ಅಪ್ಲೋಡ್ ಮುಚ್ಚಲಾ?"
					: "Cancel property upload?",
		unsavedDataWillBeLost:
			router.locale === "ar-AE"
				? "جميع البيانات غير المحفوظة ستفقد. هل أنت متأكد؟"
				: router.locale === "kn-IN"
					? "ಅಸುರಕ್ಷಿತ ಡೇಟಾ ನಷ್ಟವಾಗುತ್ತದೆ. ನಿಮಗೆ ಖಚಿತವೇ?"
					: "All the unsaved data will be lost. Are you sure ?",
		yes: router.locale === "ar-AE" ? "نعم" : router.locale === "kn-IN" ? "ಹೌದು" : "Yes",
		no: router.locale === "ar-AE" ? "لا" : router.locale === "kn-IN" ? "ಬೇಡ" : "No",
		creatingProperty:
			router.locale === "ar-AE"
				? "جاري إنشاء العقار"
				: router.locale === "kn-IN"
					? "ಆಸ್ತಿ ರಚಿಸುತ್ತಿದೆ"
					: "Creating property",
		createNewProperty:
			router.locale === "ar-AE"
				? "إنشاء عقار جديد"
				: router.locale === "kn-IN"
					? "ಹೊಸ ಆಸ್ತಿ ರಚಿಸಿ"
					: "Create new property",
		propertyLocation:
			router.locale === "ar-AE" ? "موقع العقار" : router.locale === "kn-IN" ? "ಆಸ್ತಿಯ ಸ್ಥಳ" : "Property location",
		propertyDetails:
			router.locale === "ar-AE" ? "تفاصيل العقار" : router.locale === "kn-IN" ? "ಆಸ್ತಿಯ ವಿವರಗಳು" : "Property details",
		propertyConfiguration:
			router.locale === "ar-AE"
				? "تكوين العقار"
				: router.locale === "kn-IN"
					? "ಆಸ್ತಿಯ ಸಂರಚನೆ"
					: "Property configuration",
		addOverview:
			router.locale === "ar-AE" ? "أضف نظرة عامة" : router.locale === "kn-IN" ? "ಸಾರಾಂಶ ಸೇರಿಸಿ" : "Add overview",
		uploadImages:
			router.locale === "ar-AE"
				? "رفع الصور"
				: router.locale === "kn-IN"
					? "ಚಿತ್ರಗಳನ್ನು ಅಪ್ಲೋಡ್ ಮಾಡಿ"
					: "Upload images",
		propertyPreview:
			router.locale === "ar-AE" ? "معاينة العقار" : router.locale === "kn-IN" ? "ಆಸ್ತಿಯ ಮುನ್ನೋಟ" : "Property preview",
		fieldsCannotBeEmpty:
			router.locale === "ar-AE"
				? "الحقول المعلمة بـ * هي حقول إلزامية."
				: router.locale === "kn-IN"
					? "* ಗುರುತು ಮಾಡಿದ ಕ್ಷೇತ್ರಗಳು ಕಡ್ಡಾಯವಾಗಿವೆ"
					: "Fields marked with * are mandatory",
		back: router.locale === "ar-AE" ? "رجوع" : router.locale === "kn-IN" ? "ಹಿಂದೆ" : "Back",
		preview: router.locale === "ar-AE" ? "معاينة" : router.locale === "kn-IN" ? "ಮುನ್ನೋಟ" : "Preview",
		publish: router.locale === "ar-AE" ? "نشر" : router.locale === "kn-IN" ? "ಪ್ರಕಟಿಸಿ" : "Publish",
		next: router.locale === "ar-AE" ? "التالي" : router.locale === "kn-IN" ? "ಮುಂದೆ" : "Next",
		business_name_placeholder:
			router.locale === "ar-AE"
				? "مثال: إعمار "
				: router.locale === "kn-IN"
					? "ಉದಾ: ಪ್ರೆಸ್ಟೀಜ್ ಗ್ರೂಪ್"
					: "Eg: Prestige Group",
		property_name_placeholder:
			router.locale === "ar-AE"
				? "مثال: فيلا الجميرا"
				: router.locale === "kn-IN"
					? "ಉದಾ: ಪ್ರೆಸ್ಟೀಜ್ ಟ್ರಾನ್ಕ್ವಿಲಿಟಿ"
					: "Eg: Prestige Tranquility",
		resume: router.locale === "ar-AE" ? "استئناف" : router.locale === "kn-IN" ? "ಮುಂದುವರಿಸಿ" : "Resume",
		continuePropertyUpload:
			router.locale === "ar-AE"
				? "متابعة تحميل العقار"
				: router.locale === "kn-IN"
					? "ಆಸ್ತಿಯ ಅಪ್‌ಲೋಡ್ ಮುಂದುವರಿಸಿ"
					: "Continue property upload",
		skip: router.locale === "ar-AE" ? "تخطى" : router.locale === "kn-IN" ? "ಮುಂದಕ್ಕೆ ಹೋಗಿ" : "Skip",
		go_to_my_listings:
			router.locale === "ar-AE"
				? "اذهب إلى إعلاناتي"
				: router.locale === "kn-IN"
					? "ನನ್ನ ಪಟ್ಟಿ ಗೆ ಹೋಗಿ"
					: "Go to my listings",
	};

	const stepperContent = (step: number) => {
		switch (step) {
			case 0:
				return (
					<CustomDiv
						sx={{
							flexDirection: "column",
							gap: "1rem",
							paddingTop: "1rem",
							direction: router.locale === "ar-AE" ? "rtl" : "ltr",
						}}
					>
						<PropertyNameContainer>
							{businessProfiles === undefined ? (
								<TextContainer sx={{ gap: "0rem" }}>
									<TextContainer sx={{ flexDirection: "row", justifyContent: "flrx-start", alignItems: "center" }}>
										<Typography variant="body1">{localLang.createNewBP} </Typography>
										<Tooltip title={localLang.createNewBPSubTest}>
											<InfoOutlined
												sx={{
													color: theme.palette.mode == "dark" ? "#FFFFFF" : "#0000008A",
													height: "1.25rem",
													width: "1.25rem",
												}}
											/>
										</Tooltip>
									</TextContainer>

									<TextField
										label={localLang.businessName}
										required={true}
										disabled={loading}
										value={businessProfileName}
										placeholder={localLang.business_name_placeholder}
										autoComplete="off"
										variant="outlined"
										onChange={(event: any) => {
											setBusinessProfileName(event.target.value);
											setBusinessProfileNameError(false);
										}}
										sx={{
											width: "100%",
											marginTop: "1.5rem",
											"& .MuiOutlinedInput-root": {
												borderRadius: "0.75rem",
											},
										}}
										error={businessProfileNameError}
										helperText={businessProfileNameError ? localLang.businessNameHelperText : ""}
									/>

									<FormControl
										variant="outlined"
										fullWidth
										sx={{
											marginTop: "1rem",
											borderRadius: "0.75rem",
											"& .MuiOutlinedInput-root": {
												borderRadius: "0.75rem",
											},
										}}
										error={businessProfileTypeError}
									>
										<InputLabel
											id="profile-type"
											sx={{ padding: "0rem" }}
										>
											{localLang.businessProfileType}
										</InputLabel>
										<Select
											labelId="profile-type"
											label={localLang.businessProfileType}
											required={true}
											disabled={loading}
											value={businessProfileType}
											sx={{
												width: "100%",
												borderRadius: "0.75rem",
												"& .MuiOutlinedInput-root": {
													borderRadius: "0.75rem",
												},
											}}
											onChange={(e) => {
												setBusinessProfileType(e.target.value);
											}}
										>
											<MenuItem value="agent">{localLang.agent}</MenuItem>
											<MenuItem value="developer">{localLang.developper}</MenuItem>
											<MenuItem value="landowner">{localLang.landOwner}</MenuItem>
										</Select>
										<FormHelperText>{businessProfileTypeError ? localLang.BPTypeCannotBeEmpty : ""}</FormHelperText>
									</FormControl>
								</TextContainer>
							) : null}

							<TextContainer sx={{ gap: "1rem" }}>
								<TextContainer sx={{ flexDirection: "row", justifyContent: "flex-start", alignItems: "center" }}>
									<Typography sx={{ fontSize: "1rem", fontWeight: 400, lineHeight: "150%" }}>
										{localLang.enterNamePfTHeProperty}
									</Typography>
								</TextContainer>
								<TextField
									label={localLang.propertyName}
									placeholder={localLang.property_name_placeholder}
									required={true}
									disabled={
										loading ||
										(businessProfiles === undefined && (businessProfileName === "" || businessProfileType === ""))
									}
									value={propertyTitle}
									autoComplete="off"
									variant="outlined"
									onChange={(event: any) => {
										setPropertyNameError(false);
										setPropertyTitle(event.target.value);
									}}
									sx={{
										width: "100%",
										"& .MuiOutlinedInput-root": {
											borderRadius: "0.75rem",
										},
									}}
									error={propertyNameError}
									helperText={propertyNameError ? localLang.propNameCannotBeEmpty : ""}
								/>
								{/* {businessProfiles === undefined ? null : (
									<Typography
										sx={{
											fontSize: "1rem",
											fontWeight: 400,
											lineHeight: "150%",
										}}
									>
										{localLang.postingAs}{" "}
										{businessProfiles === undefined
											? businessProfileName
											: businessProfiles
												? businessProfiles.page_title
													? businessProfiles.page_title
													: ""
												: ""}
									</Typography>
								)} */}
							</TextContainer>
						</PropertyNameContainer>
						{(previousData?.stepsCompleted ?? 0) > 0 && businessProfiles !== undefined ? (
							<DividerContainer>
								<Divider style={{ flex: 1 }} />
								<span style={{ padding: "0 8px", fontSize: "1rem", color: "#333" }}>
									{router.locale === "ar-AE" ? "أو" : "OR"}
								</span>
								<Divider style={{ flex: 1 }} />
							</DividerContainer>
						) : null}

						{/* Resume Property Upload */}

						{(previousData?.stepsCompleted ?? 0) > 0 && businessProfiles !== undefined ? (
							<ResumeUploadContainer
								onClick={() => {
									handleSetPreviousData();
								}}
							>
								<ColumnContainer>
									<Text variant="subtitle2">{localLang.continuePropertyUpload}</Text>
									<SubText variant="caption">
										{router.locale === "ar-AE"
											? "الخطوات المتبقية: " + (7 - (previousData?.stepsCompleted ?? 0))
											: router.locale === "kn-IN"
												? "ಬಾಕಿ ಇರುವ ಹಂತಗಳು: " + (7 - (previousData?.stepsCompleted ?? 0))
												: "Steps remaining: " + (7 - (previousData?.stepsCompleted ?? 0))}
										{/* Steps remaining: {7 - (previousData?.stepsCompleted ?? 0)} */}
									</SubText>
								</ColumnContainer>
								<BeegruButton
									variant="outlined"
									flavor="primary"
									sx={{
										fontSize: "0.875rem",
										fontWeight: 500,
										lineHeight: "150%",
										gap: "0.5rem",
									}}
									onClick={() => {
										handleSetPreviousData();
									}}
								>
									{localLang.resume}
									<PlayCircleOutlineOutlinedIcon sx={{ color: theme.palette.primary.main }} />
								</BeegruButton>
							</ResumeUploadContainer>
						) : null}
					</CustomDiv>
				);
			case 1:
				return (
					<PropertyLocation
						session={session}
						dispatch={dispatch}
						newPropertyDataLocationCoordinates={newPropertyData?.search_metrics?.location_coordinates}
						showMap={newPropertyData ? (newPropertyData.location.title.length > 0 ? true : false) : false}
						locationAddress={newPropertyData?.location.title}
					/>
				);
			case 2:
				return (
					<PropertyDetails
						property_transaction_type={newPropertyData?.transaction_type}
						property_category_type={newPropertyData?.property_category}
						property_type={newPropertyData?.property_type}
						property_subtype={newPropertyData?.property_subtype}
						property_min_price={newPropertyData?.price?.min}
						property_max_price={newPropertyData?.price?.max}
						property_currency={newPropertyData?.price?.currency}
						property_security_deposit={newPropertyData?.security_deposit as security_deposit}
						property_availability={newPropertyData?.availability}
						property_possession_date={newPropertyData?.possession_date}
						property_unit_facing={
							newPropertyData?.unit_facing
								? newPropertyData?.unit_facing.map(
										(element: string) => element.charAt(0).toUpperCase() + element.slice(1).replace(/_/g, " "),
									)
								: []
						}
						property_land_facing={
							newPropertyData?.land_facing
								? newPropertyData?.land_facing.map(
										(element: string) => element.charAt(0).toUpperCase() + element.slice(1).replace(/_/g, " "),
									)
								: []
						}
						property_age={newPropertyData?.property_age}
						dispatch={dispatch}
						transactionTypeError={transactionTypeError}
						setTransactionTypeError={setTransactionTypeError}
						propertyCategoryError={propertyCategoryError}
						setPropertyCategoryError={setPropertyCategoryError}
						propertyTypeError={propertyTypeError}
						setPropertyTypeError={setPropertyTypeError}
						priceMinError={priceMinError}
						setPriceMinError={setPriceMinError}
						priceMaxError={priceMaxError}
						setPriceMaxError={setPriceMaxError}
						availabilityError={availabilityError}
						setAvailabilityError={setAvailabilityError}
						possessionDateError={possessionDateError}
						setPossessionDateError={setPossessionDateError}
					/>
				);
			case 3:
				return (
					<PropertyConfig
						propertyData={newPropertyData}
						property_furnishing_status={newPropertyData?.furnished as string[]}
						property_plot_dimensions={newPropertyData?.plot_dimensions ? newPropertyData?.plot_dimensions : ["30x40"]}
						property_area={newPropertyData?.area as Area}
						property_bhk={newPropertyData?.bhk as BHK}
						property_bathroom={newPropertyData?.bathroom as BHK}
						property_balconies={newPropertyData?.balconies as BHK}
						property_floors={newPropertyData?.floors as BHK}
						property_floor_no={newPropertyData?.floor_no as BHK}
						property_no_of_units={newPropertyData?.no_of_units as BHK}
						property_no_of_seats={newPropertyData?.no_of_seats as BHK}
						dispatch={dispatch}
						session={session ? session : null}
						propertyBHKminError={propertyBHKminError}
						setPropertyBHKminError={setPropertyBHKminError}
						propertyBHKmaxError={propertyBHKmaxError}
						setPropertyBHKmaxError={setPropertyBHKmaxError}
						propertyBathroomMinError={propertyBathroomMinError}
						setPropertyBathroomMinError={setPropertyBathroomMinError}
						propertyBathroomMaxError={propertyBathroomMaxError}
						setPropertyBathroomMaxError={setPropertyBathroomMaxError}
						propertyNoOfUnitsError={propertyNoOfUnitsError}
						setPropertyNoOfUnitsError={setPropertyNoOfUnitsError}
						propertyNoOfSeatsError={propertyNoOfSeatsError}
						setPropertyNoOfSeatsError={setPropertyNoOfSeatsError}
						propertyPlotDimensionsError={propertyPlotDimensionsError}
						setPropertyPlotDimensionsError={setPropertyPlotDimensionsError}
						propertyLandAreaError={propertyLandAreaError}
						setPropertyLandAreaError={setPropertyLandAreaError}
						propertySuperBuiltUpMinAreaError={propertySuperBuiltUpMinAreaError}
						setPropertySuperBuiltUpMinAreaError={setPropertySuperBuiltUpMinAreaError}
						propertySuperBuiltUpMaxAreaError={propertySuperBuiltUpMaxAreaError}
						setPropertySuperBuiltUpMaxAreaError={setPropertySuperBuiltUpMaxAreaError}
						propertyPermitNumberError={propertyPermitNumberError}
						setPropertyPermitNumberError={setPropertyPermitNumberError}
						propertyBlnError={propertyBlnError}
						setPropertyBlnError={setPropertyBlnError}
					/>
				);
			case 4:
				return (
					<PropertyOverview
						overview_data={newPropertyData?.description}
						dispatch={dispatch}
					/>
				);
			case 5:
				return (
					<UploadImages
						newPropertyData={newPropertyData}
						dispatch={dispatch}
						session={session ? session : null}
						businessProfiles={businessProfiles as DbUserPage}
						isBusinessProfile={true}
						isNewBusinessProfile={createBusinessProfile}
					/>
				);
			case 6:
				return (
					<PropertyPreview
						property_photo_count={newPropertyData?.images ? newPropertyData.images.length : 0}
						onEditStep={(step: number) => {
							setReturnToReview(true);
							setActiveStep(step);
						}}
						property_title={propertyTitle ? propertyTitle : ""}
						property_location={newPropertyData?.location.title ? newPropertyData?.location.title : ""}
						property_overview={newPropertyData?.description ? newPropertyData?.description : ""}
						property_transaction_type={newPropertyData?.transaction_type ? newPropertyData?.transaction_type : ""}
						property_category={newPropertyData?.property_category ? newPropertyData?.property_category : ""}
						property_type={newPropertyData?.property_type ? newPropertyData?.property_type : []}
						property_min_price={newPropertyData?.price?.min ? newPropertyData?.price?.min : 0}
						property_max_price={newPropertyData?.price?.max ? newPropertyData?.price?.max : 0}
						property_currency={newPropertyData?.price?.currency ? newPropertyData?.price?.currency : "INR"}
						property_security_deposit={
							newPropertyData?.security_deposit.max ? newPropertyData?.security_deposit.max : 0
						}
						property_availability={newPropertyData?.availability ? newPropertyData?.availability : []}
						property_possession_date={newPropertyData?.possession_date ? newPropertyData?.possession_date : ""}
						property_unit_facing={
							newPropertyData?.unit_facing
								? newPropertyData?.unit_facing.map(
										(element: string) => element.charAt(0).toUpperCase() + element.slice(1).replace(/_/g, " "),
									)
								: []
						}
						property_age={newPropertyData?.property_age ? newPropertyData?.property_age : 0}
						property_furnishing_status={newPropertyData?.furnished as string[]}
						property_plot_dimensions={newPropertyData?.plot_dimensions ? newPropertyData?.plot_dimensions : []}
						property_area={newPropertyData?.area as Area}
						property_bhk={newPropertyData?.bhk as BHK}
						property_bathroom={newPropertyData?.bathroom as BHK}
						property_balconies={newPropertyData?.balconies as BHK}
						property_floors={newPropertyData?.floors as BHK}
						property_no_of_units={newPropertyData?.no_of_units as BHK}
						property_no_of_seats={newPropertyData?.no_of_seats as BHK}
					/>
				);
		}
	};

	return (
		<React.Fragment>
			{/* Alert dialog */}

			<Snack
				open={openSnackbar}
				autoHideDuration={3000}
				onClose={() => setOpenSnackbar(false)}
				anchorOrigin={{ vertical: "top", horizontal: "center" }}
			>
				<Alert
					onClose={() => setOpenSnackbar(false)}
					severity={newPropertyData?.snack_text === "Error while creating Property" ? "error" : "success"}
					sx={{ width: "100%", borderRadius: "0.75rem" }}
					variant="filled"
				>
					{newPropertyData?.snack_text}
				</Alert>
			</Snack>

			{/* Closing part-way asks (3 Nov 2026, the app's Save & Exit and Discard): Save & exit keeps a draft (a server draft
			    under Unlisted for an existing business, else this browser's copy); Discard drops what was entered. */}
			<Dialog
				open={alertModal}
				maxWidth="xs"
				fullWidth={true}
				onClose={() => {
					setAlertModal(false);
				}}
			>
				<DialogTitle sx={{ fontSize: "1.25rem", fontWeight: 500, lineHeight: "160%" }}>
					{router.locale === "ar-AE" ? "حفظ وخروج؟" : router.locale === "kn-IN" ? "ಉಳಿಸಿ ಮತ್ತು ನಿರ್ಗಮಿಸುವುದೇ?" : "Save & exit?"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText>
						{router.locale === "ar-AE"
							? "سيُحفظ عقارك كمسودة مع الصور. يمكنك المتابعة في أي وقت من القوائم."
							: router.locale === "kn-IN"
								? "ನಿಮ್ಮ ಪಟ್ಟಿಯನ್ನು ಫೋಟೋಗಳ ಸಹಿತ ಕರಡಾಗಿ ಉಳಿಸಲಾಗುತ್ತದೆ. ಪಟ್ಟಿಗಳಿಂದ ಯಾವಾಗ ಬೇಕಾದರೂ ಮುಂದುವರಿಸಿ."
								: "Your listing will be saved as a draft, photos included. You can resume anytime from Listings."}
					</DialogContentText>
					<DialogContentText sx={{ marginTop: "0.5rem", fontSize: "0.8125rem" }}>
						{draftId
							? router.locale === "ar-AE"
								? "التجاهل يحذف التغييرات منذ فتح هذه المسودة؛ تبقى المسودة المحفوظة في القوائم."
								: router.locale === "kn-IN"
									? "ತಿರಸ್ಕರಿಸಿದರೆ ಈ ಕರಡು ತೆರೆದ ನಂತರದ ಬದಲಾವಣೆಗಳು ಹೋಗುತ್ತವೆ; ಉಳಿಸಿದ ಕರಡು ಪಟ್ಟಿಗಳಲ್ಲಿ ಉಳಿಯುತ್ತದೆ."
									: "Discard drops the changes you've made since opening this draft. Your saved draft stays in Listings."
							: router.locale === "ar-AE"
								? "التجاهل يحذف كل ما أدخلته لهذا العقار، بما في ذلك الصور. لا يمكن التراجع."
								: router.locale === "kn-IN"
									? "ತಿರಸ್ಕರಿಸಿದರೆ ಫೋಟೋಗಳ ಸಹಿತ ನೀವು ನಮೂದಿಸಿದ ಎಲ್ಲವೂ ಹೋಗುತ್ತದೆ. ಇದನ್ನು ರದ್ದುಗೊಳಿಸಲಾಗುವುದಿಲ್ಲ."
									: "Discard deletes everything you've entered for this listing, including any photos. This can't be undone."}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<BeegruButton
						onClick={() => setAlertModal(false)}
						flavor="primary"
						variant="text"
					>
						{router.locale === "ar-AE" ? "متابعة التعديل" : router.locale === "kn-IN" ? "ಸಂಪಾದನೆ ಮುಂದುವರಿಸಿ" : "Keep editing"}
					</BeegruButton>
					<BeegruButton
						onClick={() => closeWizard(true)}
						flavor="error"
						variant="outlined"
					>
						{router.locale === "ar-AE" ? "تجاهل" : router.locale === "kn-IN" ? "ತಿರಸ್ಕರಿಸಿ" : "Discard"}
					</BeegruButton>
					<BeegruButton
						onClick={() => closeWizard(false)}
						flavor="primary"
						variant="contained"
					>
						{router.locale === "ar-AE" ? "حفظ وخروج" : router.locale === "kn-IN" ? "ಉಳಿಸಿ ಮತ್ತು ನಿರ್ಗಮಿಸಿ" : "Save & exit"}
					</BeegruButton>
				</DialogActions>
			</Dialog>

			<CustomDialog
				open={open}
				maxWidth="sm"
				fullWidth={true}
				fullScreen={smDevice}
				TransitionComponent={DialogTransition}
			>
				{/* {activeStep === 7 ? null : ( */}
				<div
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						width: "100%",
						height: "100%",
						backgroundColor: "rgba(0, 0, 0, 0.5)",
						display: loadNext ? "flex" : "none",
						justifyContent: "center",
						alignItems: "center",
						zIndex: 2,
						scrollbarWidth: "none", // Hide the scrollbar for firefox
					}}
				>
					<div style={{ textAlign: "center" }}>
						<CircularProgress size={48} />
					</div>
				</div>
				{/* )} */}
				{activeStep === 7 ? null : (
					<CustomDialogTitle>
						<TextContainer sx={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
							<IconTitleRow>
								{!loading && activeStep > 0 ? (
									<IconButton
										aria-label="back"
										sx={{
											paddingLeft: "0rem",
										}}
										onClick={handleBack}
									>
										<ArrowBack fontSize="small" />
									</IconButton>
								) : null}

								<Typography variant="body1">
									{activeStep === 0
										? localLang.createNewProperty
										: activeStep === 1
											? localLang.propertyLocation
											: activeStep === 2
												? localLang.propertyDetails
												: activeStep === 3
													? localLang.propertyConfiguration
													: activeStep === 4
														? localLang.addOverview
														: activeStep === 5
															? localLang.uploadImages
															: localLang.propertyPreview}
								</Typography>
							</IconTitleRow>

							<IconButton
								aria-label="close"
								onClick={() => {
									// Part-way through, ask first: Save & exit or Discard (the first step has nothing to keep yet).
									if (activeStep > 0 && activeStep < 7) setAlertModal(true);
									else closeWizard(false);
								}}
							>
								{loading ? null : <Close fontSize="small" />}
							</IconButton>
						</TextContainer>

						<ProgressContainer>
							<CustomLinearProgress
								variant="determinate"
								value={(activeStep / 6) * 100}
							/>
						</ProgressContainer>
					</CustomDialogTitle>
				)}
				{activeStep === 7 ? (
					<SuccessPage
						session={session}
						handleClose={() => {
							// setOpenSuccessModal(false);
							handleModalClose();
						}}
						propertyId={newPropertyData?._id ? newPropertyData._id : ""}
						dispatch={dispatch}
						profile_context={session?.user?.dbUser?.profile_context as BeegruUserProfileContext}
						router={router}
						businessType={createBusinessProfile ? businessProfileType.toLowerCase() : businessProfiles?.page_type || ""}
						new_listing_url={new_listing_url}
						propertyStatus={newPropertyData?.status || ""}
						business_profile_id={businessProfiles?.page_id || ""}
						transactionType={newPropertyData?.transaction_type || ""}
						broadcastData={broadcastData}
						broadcastFeatureDiscoveryTracker={broadcastFeatureDiscoveryTracker}
					/>
				) : (
					<CustomDialogContent
						sx={{
							padding:
								activeStep === 2 || activeStep === 3
									? "1rem 1rem 0rem 1rem"
									: activeStep === 7
										? "0rem"
										: "1rem 1rem 0rem 1rem",
							background:
								activeStep === 6
									? theme.palette.background.default
									: activeStep === 7
										? "#12744F"
										: theme.palette.background.paper,
						}}
					>
						{stepperContent(activeStep)}

						{activeStep === 2 || activeStep === 3 ? (
							<div
								style={{
									display: "flex",
									flexDirection: "row",
									justifyContent: "flex-start",
									alignItems: "center",
									width: "100%",
								}}
							>
								<Typography
									sx={{
										fontSize: "0.875rem",
										fontWeight: 400,
										lineHeight: "150%",
										color: theme.palette.mode === "dark" ? "#FFFFFF" : "#9E9E9E",
									}}
								>
									{localLang.fieldsCannotBeEmpty}
								</Typography>
							</div>
						) : null}
					</CustomDialogContent>
				)}
				{activeStep === 7 ? null : (
					<CustomDiv
						sx={{
							padding: "0.5rem",
							borderRadius: smDevice ? "8px 8px 0px 0px" : "0px",
							boxShadow: smDevice
								? "rgba(0, 0, 0, 0.2) 0px 3px 3px 2px, rgba(0, 0, 0, 0.14) 0px 3px 4px 0px, rgba(0, 0, 0, 0.12) 0px 1px 8px 0px"
								: "none",
						}}
					>
						{!loadNext ? (
							<TextContainer
								sx={{
									flexDirection: "row",
									width: "100%",
									justifyContent: smDevice ? "space-between" : "flex-end",
									alignItems: "center",
									gap: "1rem",
								}}
							>
								{activeStep !== 6 ? (
									<BeegruButton
										size="medium"
										flavor="primary"
										variant="contained"
										disableRipple
										disableFocusRipple
										disableTouchRipple
										fullWidth={smDevice}
										onClick={handleNext}
										disabled={stepOneComplete || !stepFiveCompleted}
										sx={{ minWidth: "8.75rem" }}
									>
										{activeStep === 5
											? localLang.preview
											: activeStep === 4 && newPropertyData?.description === ""
												? localLang.skip
												: localLang.next}
									</BeegruButton>
								) : (
									<BeegruButton
										size="medium"
										flavor="primary"
										variant="contained"
										disableRipple
										disableFocusRipple
										disableTouchRipple
										fullWidth={smDevice}
										onClick={handleClickCreateNewProperty}
										// disabled={}
										sx={{ minWidth: "8.75rem" }}
									>
										{localLang.publish}
									</BeegruButton>
								)}
							</TextContainer>
						) : null}
					</CustomDiv>
				)}
			</CustomDialog>
		</React.Fragment>
	);
};

export default CreatePropertyWithUploadTool;
